import React from "react";
import { TextInputV2 } from "@boi/react-components";

import Container from "./container";
import { FieldDescription, LabelContainer } from "./styled/container";
import BoiReactMarkdown from "../../boi-markdown/boi-markdown";
import { BoiTooltip } from "../../boi-tooltip/boi-tooltip";

const SingleInputEmail = ({ onChange = null, ...props }) => {
    return (
        <Container {...props}>
            <TextInputV2
                value={props.value}
                placeholder={props.placeholder || ""}
                onChange={(newValue) => onChange && onChange(newValue.trim())}
                onBlur={(e) => onChange && onChange(e.target.value.trim())}
                type="email"
                id={props.id}
                aria-label={props.label}
                isRequired={props.isRequired}
                isInvalid={!!props.error}
            />
        </Container>
    );
}

const MultiInputEmail = ({
    onChange = null,
    inputs,
    isRequired,
    cssClass,
    description,
    customTooltip,
    ...props
}) => {
    const values = props.value || {};

    return (
        <Container
            {...props}
            label={null}
            description={null}
            cssClass="double-input">
            {inputs.map(({ id, customLabel, placeholder, label }, index) => (
                <React.Fragment key={id}>
                    <LabelContainer className={index !== 0 ? "u-mt-6" : ""} style={{ order: 5 }}>
                        <label
                            htmlFor={`${props.id}.${index}`}
                            className={`field-label ${cssClass}`}>
                            {customLabel ? customLabel : label}{" "}
                            {isRequired ? (
                                ""
                            ) : (
                                <span className="optional">{"(optional)"}</span>
                            )}
                        </label>
                        {customTooltip && index === 0 && (
                            <BoiTooltip
                                id={`${props.id}_${index}`}
                                customTooltip={customTooltip}>
                                {customTooltip}
                            </BoiTooltip>
                        )}
                    </LabelContainer>
                    {index === 0 ? (
                        <div style={{ order: 5 }}>
                            <FieldDescription>
                                <BoiReactMarkdown>
                                    {description}
                                </BoiReactMarkdown>
                            </FieldDescription>
                        </div>
                    ) : (
                        ""
                    )}
                    <TextInputV2
                        value={values[id] || ""}
                        placeholder={placeholder || ""}
                        onChange={(newValue) => {
                            const update = {
                                ...values,
                                [id]: newValue.trim()
                            };
                            onChange && onChange(update);
                        }}
                        onPaste={index !== 0
                            ? e => e.preventDefault()
                            : undefined}
                        type="email"
                        id={`${props.id}.${index}`}
                        // remove this aria-label if the Container component has deleted and the label and other props are passed to TextInputV2
                        aria-label={props.label}
                        isRequired={isRequired}
                        isInvalid={!!props.error}
                    />

                </React.Fragment>
            ))}
        </Container>
    );
};

const Email = props => {
    return props.inputs ? (
        <MultiInputEmail {...props} />
    ) : (
        <SingleInputEmail {...props} />
    );
};

export default Email;
